import { useAppDispatch, useAppSelector, useAppTranslation, useErrTranslation } from 'app/hooks';
import ConditionButton from 'components/Commons/ConditionButton';
import { PLACE_BET_AUDIO } from 'consts/app';
import {
  selectCurrentConverter,
  selectCurrentTurbo,
  selectFutureBets,
  setFetchMyBet,
} from 'features/home/homeSlice';
import { useHandleGetWallets } from 'hooks/useHandleGetWallets';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import { FutureOddModel } from 'models';
import { useEffect, useState } from 'react';
import BigNumber from 'bignumber.js';
import oddsApi from 'api/oddsApi';
import { showErrorModal, showSuccessModal } from 'components/Modals/CommonModals';
import { handleFutureBetClick } from 'features/home/logic/common/odd';
import useUserDetail from 'hooks/useUserDetail';
import walletApi from 'api/walletApi';

interface FutureOddButtonProps {
  odd: FutureOddModel;
  isShowAnimation?: string;
  index: number;
  futureId: string;
  team: string;
  category: string;
  ignoreTopValue?: boolean;
  league: string;
}

const FutureOddButton: React.FunctionComponent<FutureOddButtonProps> = ({
  odd,
  isShowAnimation = 'none',
  futureId,
  team,
  category,
  ignoreTopValue = false,
  league,
}) => {
  const { id, price, decimalPrice } = odd;
  const [showAnimation, setShowAnimation] = useState<string>('none');
  const converter = useAppSelector(selectCurrentConverter);
  const bets = useAppSelector(selectFutureBets);
  const dispatch = useAppDispatch();
  const isActive = bets.findIndex((bet) => bet.odd.id === odd.id);
  const currentTurbo = useAppSelector(selectCurrentTurbo);
  const t = useAppTranslation();
  const et = useErrTranslation();
  const handleResponseError = useHandleResponseError();
  const { getWallet, currentWallet } = useHandleGetWallets();
  const { currentUser } = useUserDetail();
  useEffect(() => {
    if (isShowAnimation !== 'none') {
      if (isShowAnimation === 'increase') setShowAnimation('animated-border-green');
      else setShowAnimation('animated-border-red');
      setTimeout(() => {
        setShowAnimation('');
      }, 2000);
    } else {
      setShowAnimation('');
    }
  }, [isShowAnimation]);

  const onClickOdd = () => {
    handleFutureBetClick(odd, bets, dispatch, team, futureId, category, league);
  };

  const onPlaceBet = async () => {
    if (!currentTurbo || currentTurbo === 'none') return;
    let bettingAmount = Number(currentTurbo);
    if (currentUser?.coinDto.symbol !== 'USD') {
      const { ok, body } = await walletApi.getTokenPrice(currentUser?.coinDto.symbol as string);
      if (ok && body) {
        bettingAmount = bettingAmount / body.price;
      }
    }
    const { ok, error } = await oddsApi.placingBets({
      bets: [
        {
          futureId: futureId,
          oddsId: id,
          amount: bettingAmount,
          market: '',
        },
      ],
    });

    if (ok) {
      aud.play();
      getWallet();
      dispatch(setFetchMyBet(true));
      showSuccessModal({
        title: t('bet.success.title'),
        content: t('bet.success.message'),
      });
    }
    if (error) {
      if (error?.fieldErrors) {
        showErrorModal({
          content: et(error.fieldErrors.bets[0]),
          title: et(error.title || '', { defaultValue: et('defaultMessage.title') }),
        });
      } else handleResponseError(error);
    }
  };
  return (
    <ConditionButton
      isSkipCheckOnClick
      content={
        <p className="price">
          {converter === 'american'
            ? `${price > 0 ? '+' : ''}${new BigNumber(price).toFixed(0)}`
            : decimalPrice}
        </p>
      }
      className={`button__odd button__odd${isActive !== -1 ? '-active' : ''} ${showAnimation}`}
      onClick={onClickOdd}
      onDoubleClick={onPlaceBet}
      testerCheck={true}
    />
  );
};

export default FutureOddButton;
const aud = new Audio(PLACE_BET_AUDIO);
